import(/* webpackMode: "eager" */ "/home/runner/work/1/s/packages/app/src/app/(client)/(authenticated)/page.tsx");
